<div class="w-full bg-white border-box radius-10" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="period-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Dates et organisation des scrutins</p>
            <p class="no-margin dark-gray text-sm">
              Dates d'ouverture et de fermeture des votes (les horaires seront configurés à l'étape 2)
            </p>
          </div>
        </div>

      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>
    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>

  <div *ngIf="isExpanded" class="p-20">
    <h3 class="dark-blue bold text-md no-margin mb-10">Premier tour</h3>
    <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;" class="mb-30">
      <div>
        <p class="dark-gray no-margin">Date d'ouverture</p>
        <div>
          <p class="no-margin dark-blue bold">{{fROpeningString}}</p>
          <!-- <input type="date" name="first_open" id="first_open" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="fROpeningString" [min]="minDate"> -->

          <!-- <input type="time" name="first_open_time" id="first_open_time" class="text-md dark-blue title-input"
            style="width: 40%;" [(ngModel)]="fROpeningTime"> -->
        </div>
      </div>

      <div>
        <p class="dark-gray no-margin">Date de clôture</p>
        <div>
          <p class="no-margin dark-blue bold">{{fRClosingString}}</p>
          <!-- <input type="date" name="first_close" id="first_close" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="fRClosingString" [min]="minFirstClosingDate"> -->
          <!-- <input type="time" name="first_close_time" id="first_close_time" class="text-md dark-blue title-input"
          style="width: 40%;" [(ngModel)]="fRClosingTime"> -->
        </div>
      </div>
    </div>


    <h3 class="dark-blue bold text-md no-margin mb-10">Second tour</h3>

    <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;">
      <div>
        <p class="dark-gray no-margin">Date d'ouverture</p>
        <div>
          <p class="no-margin dark-blue bold">{{sROpeningString}}</p>
          <!-- <input type="date" name="second_open" id="second_open" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="sROpeningString" [min]="minDate"> -->

          <!-- <input type="time" name="second_open_time" id="second_open_time" class="text-md dark-blue title-input"
          style="width: 40%;" [(ngModel)]="sROpeningTime"> -->
        </div>
      </div>

      <div>
        <p class="dark-gray no-margin">Date de clôture</p>
        <div>
          <p class="no-margin dark-blue bold">{{sRClosingString}}</p>
          <!-- <input type="date" name="second_close" id="second_close" class="text-md dark-blue pap-input w-full"
            [(ngModel)]="sRClosingString" [min]="minSecondClosingDate"> -->
          <!-- <input type="time" name="second_close_time" id="second_close_time" class="text-md dark-blue title-input"
          style="width: 40%;" [(ngModel)]="sRClosingTime"> -->
        </div>
      </div>
    </div>

  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>
  </div>
</div>